export const CHANGE_LANG_FETCHING = 'CHANGE_LANG_FETCHING'
export const CHANGE_LANG_SUCCESS = 'CHANGE_LANG_SUCCESS '
export const CHANGE_LANG_FAILURE = 'CHANGE_LANG_FAILURE'
